import React from 'react'
import { DataTable, ColumnDefinition, CellDefinition } from 'common/components/DataTable'
import Utils from 'common/Utils'
import { AmountByTag, MovementFilterNode } from 'types'
import MonthOfYear from 'common/logic/MonthOfYear'
import { encodeFilterTree } from 'common/logic/FilterTree'

interface Props {
    entries: Record<string, AmountByTag[]>
    total: Record<string, number>
    month: MonthOfYear
}

function buildMonthFilterTree(startDate: string, endDate: string, tagNode: MovementFilterNode): MovementFilterNode {
    return {
        kind: 'all',
        children: [
            { kind: 'leaf', type: 'DATE_AFTER',  parameter: startDate },
            { kind: 'leaf', type: 'DATE_BEFORE', parameter: endDate },
            tagNode,
        ]
    }
}

function ExpenseByTagTable({ entries, total, month }: Props) {
    const startDate = month.firstDay().format('YYYY-MM-DD')
    const endDate = month.lastDay().format('YYYY-MM-DD')

    const tagLink = (obj: AmountByTag) => {
        let tagNode: MovementFilterNode
        if (!obj.tag) {
            tagNode = { kind: 'leaf', type: 'HAS_NO_TAGS', parameter: '' }
        } else {
            tagNode = { kind: 'leaf', type: 'HAS_TAG', parameter: String(obj.tag.id) }
        }
        const filter = encodeFilterTree(buildMonthFilterTree(startDate, endDate, tagNode))
        const url = Utils.urlWithParameters('/movements', null, { filter })
        return <a href={url}>{obj.tag ? obj.tag.name : 'Untagged'}</a>
    }

    const currencies = Object.keys(total)
    return <>
        {currencies.map(curr => {
            const rows = [...(entries[curr] ?? [])].sort(
                (a, b) => Math.abs(Number(b.amount)) - Math.abs(Number(a.amount))
            )
            const columnDefinitions = [
                new ColumnDefinition<AmountByTag>("Tag", obj => tagLink(obj)),
                new ColumnDefinition<AmountByTag>(
                    "Amount",
                    obj => <>{Utils.formatMoney(obj.amount, true)} {curr}</>,
                    "td-currency",
                    "td-right"
                ),
            ]
            const summaryRow = [
                new CellDefinition('TOTAL', 'td-total'),
                new CellDefinition(<>{Utils.formatMoney(total[curr], true)} {curr}</>, 'td-currency'),
            ]
            return <React.Fragment key={curr}>
                {currencies.length > 1 && <h2>{curr}</h2>}
                <DataTable
                    columns={columnDefinitions}
                    rows={rows}
                    summaryRows={[summaryRow]}
                />
            </React.Fragment>
        })}
    </>
}

export default ExpenseByTagTable
